/**
 * Call verify-otp-and-signin Edge Function via direct fetch (avoids functions.invoke() failures).
 * Retries once on network failure. Throws with Arabic message if request cannot be sent.
 * @param {{ phone: string, code: string, role?: string, userData?: object }} payload
 * @returns {Promise<{ success?: boolean, redirectUrl?: string, error?: string }>}
 */
const RETRY_DELAY_MS = 1500;
const CONNECTION_ERROR_MSG =
  "تعذر الاتصال بخدمة التحقق. تحقق من الاتصال وأعد المحاولة.";

async function doRequest(payload) {
  const url = import.meta.env?.VITE_SUPABASE_URL;
  const anonKey = import.meta.env?.VITE_SUPABASE_ANON_KEY;
  if (!url || !anonKey) {
    throw new Error(CONNECTION_ERROR_MSG);
  }
  const functionUrl = `${url.replace(/\/$/, "")}/functions/v1/verify-otp-and-signin`;
  const res = await fetch(functionUrl, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${anonKey}`,
      "Content-Type": "application/json",
      apikey: anonKey,
    },
    body: JSON.stringify(payload),
  });

  let data;
  try {
    data = await res.json();
  } catch {
    throw new Error(CONNECTION_ERROR_MSG);
  }

  if (!res.ok) {
    throw new Error(data?.error || data?.message || "فشل التحقق");
  }
  return data;
}

export async function verifyOtpAndSignIn(payload) {
  const { phone, code, role, userData, msegatId } = payload;
  if (!phone || !code) {
    throw new Error("رقم الجوال والرمز مطلوبان");
  }
  const body = { phone, code };
  if (role != null) body.role = role;
  if (userData != null) body.userData = userData;
  if (payload.msegatId != null) body.msegatId = payload.msegatId;

  try {
    return await doRequest(body);
  } catch (err) {
    if (err.message === CONNECTION_ERROR_MSG || err.message?.includes("fetch") || err.name === "TypeError") {
      await new Promise((r) => setTimeout(r, RETRY_DELAY_MS));
      return await doRequest(body);
    }
    throw err;
  }
}
